import { c as _c } from "react/compiler-runtime";
import { Edit03Icon, EyeIcon, SwitchHorizontal01Icon } from '@systemeio/icons';
import { useResetFunnelStepPageTemplate } from 'modules/funnels/funnel/hooks/use-reset-funnel-step-page-template';
import { FunnelStepId, FunnelStepPageId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useState, type ReactNode } from 'react';
import { Button, Tooltip } from 'shared/components';
import ConfirmationModal from 'shared/components/confirmation-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
import { twJoin } from 'tailwind-merge';
interface FunnelStepActionsProps {
  funnelId: FunnelId;
  funnelStepId: FunnelStepId;
  pageId: FunnelStepPageId;
  viewLinkUrl?: string;
  editDisabledReason?: string;
  additionalAction?: ReactNode;
}
function FunnelStepActions(t0) {
  const $ = _c(64);
  const {
    funnelId,
    funnelStepId,
    pageId,
    viewLinkUrl,
    editDisabledReason,
    additionalAction
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isDesktop,
    isMobile
  } = useMediaQuery();
  const [changeTemplateConfirmationOpen, setChangeTemplateConfirmationOpen] = useState(false);
  let t1;
  if ($[0] !== funnelId || $[1] !== funnelStepId) {
    t1 = {
      funnelId,
      funnelStepId
    };
    $[0] = funnelId;
    $[1] = funnelStepId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    resetFunction
  } = useResetFunnelStepPageTemplate(t1);
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.funnel.configuration.common.view_funnel_step");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const viewFunnelStepLabel = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.funnel.configuration.common.change_page_template");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const changePageTemplateLabel = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.funnel.configuration.common.edit_page");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const editPageLabel = t4;
  const secondaryActionSize = isDesktop ? "sm" : "icon-md";
  const secondaryActionLabelClassName = isDesktop ? undefined : "sr-only";
  const t5 = isMobile && (editDisabledReason ? "w-full" : "flex-1");
  let t6;
  if ($[9] !== t5) {
    t6 = twJoin(t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = Boolean(editDisabledReason);
  const t8 = isDesktop ? "sm" : "md";
  let t9;
  if ($[11] !== editDisabledReason || $[12] !== pageId) {
    t9 = editDisabledReason ? undefined : <LinkWithoutPrefetch href={getPageEditorUrl(pageId)} target="_self" />;
    $[11] = editDisabledReason;
    $[12] = pageId;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Edit03Icon />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== editPageLabel) {
    t11 = <span>{editPageLabel}</span>;
    $[15] = editPageLabel;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== editPageLabel || $[18] !== t11 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <Button aria-label={editPageLabel} className={t6} data-test-element="edit-page-funnel-step-button" disabled={t7} variant="primary" size={t8} render={t9}>{t10}{t11}</Button>;
    $[17] = editPageLabel;
    $[18] = t11;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const editButton = t12;
  const t13 = !viewLinkUrl;
  let t14;
  if ($[24] !== viewLinkUrl) {
    t14 = viewLinkUrl ? <LinkWithoutPrefetch href={viewLinkUrl} rel="noreferrer" target="_blank" /> : undefined;
    $[24] = viewLinkUrl;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <EyeIcon />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== secondaryActionLabelClassName || $[28] !== viewFunnelStepLabel) {
    t16 = <span className={secondaryActionLabelClassName}>{viewFunnelStepLabel}</span>;
    $[27] = secondaryActionLabelClassName;
    $[28] = viewFunnelStepLabel;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== secondaryActionSize || $[31] !== t13 || $[32] !== t14 || $[33] !== t16 || $[34] !== viewFunnelStepLabel) {
    t17 = <Button aria-label={viewFunnelStepLabel} data-test-element="view-funnel-step-button" disabled={t13} title={viewFunnelStepLabel} variant="secondary" size={secondaryActionSize} render={t14}>{t15}{t16}</Button>;
    $[30] = secondaryActionSize;
    $[31] = t13;
    $[32] = t14;
    $[33] = t16;
    $[34] = viewFunnelStepLabel;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setChangeTemplateConfirmationOpen(true);
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <SwitchHorizontal01Icon />;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== changePageTemplateLabel || $[39] !== secondaryActionLabelClassName) {
    t20 = <span className={secondaryActionLabelClassName}>{changePageTemplateLabel}</span>;
    $[38] = changePageTemplateLabel;
    $[39] = secondaryActionLabelClassName;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== changePageTemplateLabel || $[42] !== secondaryActionSize || $[43] !== t20) {
    t21 = <Button aria-label={changePageTemplateLabel} onClick={t18} data-test-element="change-page-template-funnel-step-button" title={changePageTemplateLabel} variant="secondary" size={secondaryActionSize}>{t19}{t20}</Button>;
    $[41] = changePageTemplateLabel;
    $[42] = secondaryActionSize;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== additionalAction || $[46] !== t17 || $[47] !== t21) {
    t22 = <div className="flex items-center gap-3">{t17}{t21}{additionalAction}</div>;
    $[45] = additionalAction;
    $[46] = t17;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== editButton || $[50] !== editDisabledReason || $[51] !== isMobile) {
    t23 = editDisabledReason ? <Tooltip mode="hover" label={editDisabledReason} triggerProps={{
      className: twJoin(isMobile && "flex-1")
    }}>{editButton}</Tooltip> : editButton;
    $[49] = editButton;
    $[50] = editDisabledReason;
    $[51] = isMobile;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t) {
    t24 = t("dashboard.funnel.configuration.common.change_page_template_confirm");
    $[53] = t;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setChangeTemplateConfirmationOpen(false);
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== changeTemplateConfirmationOpen || $[57] !== resetFunction || $[58] !== t24) {
    t26 = <ConfirmationModal status="error" confirmationText={t24} opened={changeTemplateConfirmationOpen} onClose={t25} onConfirm={resetFunction} />;
    $[56] = changeTemplateConfirmationOpen;
    $[57] = resetFunction;
    $[58] = t24;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t22 || $[61] !== t23 || $[62] !== t26) {
    t27 = <>{t22}{t23}{t26}</>;
    $[60] = t22;
    $[61] = t23;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  return t27;
}
export { FunnelStepActions };
export type { FunnelStepActionsProps };